import './PageLayout.css';

import React, { ReactNode, useState } from 'react';
import { IonPage } from '@ionic/react';
import useDocumentTitle from '../../hooks/useDocumentTitle';
// import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
// import LanguageSwitcherAccordion from '../LanguageSwitcherAccordion/LanguageSwitcherAccordion';
import OfflinePanel from '../../components/OfflinePanel/OfflinePanel';
import { useLogout } from '../../api/hooks/useLogout';
import useApiErrorHandling from '../../hooks/useApiErrorHandling';
import { useTranslate } from '../../hooks/context/useTranslate';
import Loading from '../../components/Loading/Loading';
import SupportModal from '../../components/SupportModal/SupportModal';
import Header from './components/Header';
import Content from './components/Content';
import DatasetSessionStorageContextProvider from '../../context/DatasetSessionStorageContext/DatasetSessionStorageContext';

interface PageLayoutProps {
  children?: React.ReactNode;
  className?: string;
  isLoading?: boolean;
  peersets?: any[];
  filter?: ReactNode;
  onMenuItemClick?: (url: string) => void;
}

// Provides the session-storage context so PageLayout works in every router branch (incl. error/loading
// pages rendered outside LoggedInLayout); consumers like useLogout and the side-menu search rely on it.
const PageLayout = (props: PageLayoutProps) => (
  <DatasetSessionStorageContextProvider>
    <PageLayoutContent {...props} />
  </DatasetSessionStorageContextProvider>
);

const PageLayoutContent = ({
  children,
  className = '',
  isLoading,
  peersets,
  filter = undefined,
  onMenuItemClick,
}: PageLayoutProps) => {
  const { logout, isPending } = useLogout();
  const handleApiError = useApiErrorHandling();
  const { t } = useTranslate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  useDocumentTitle();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (e) {
      handleApiError(e);
    }
  };

  const handleOnPopoverOpen = () => {
    setIsModalOpen(true);
  };

  return (
    <IonPage className={className}>
      <SupportModal
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      />
      <OfflinePanel />
      {isPending && <Loading message={t('loggingOut')} />}
      <Header
        onPopoverOpen={handleOnPopoverOpen}
        onLogout={handleLogout}
        filter={filter}
      />
      <Content
        isLoading={isLoading}
        peersets={peersets}
        onMenuItemClick={onMenuItemClick}
      >
        {children}
      </Content>
    </IonPage>
  );
};

export default PageLayout;
